export default {"src":"/customer-services/_next/static/media/repair.cc2af923.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};